import { configureStore } from '@reduxjs/toolkit';
import AuthReducer from './features/auth/AuthSlice';
import ClassReducer from './features/class/ClassSlice';
import EduSubjectReducer from './features/edusubject/edusubjectSlice';
import QuestionsGroupReducer from './features/questionsgroup/QuestionsGroup';
const Store = configureStore({
    reducer: {
        auth: AuthReducer,
        class: ClassReducer,
        eduSubjects: EduSubjectReducer,
        userQuestionsGroups:QuestionsGroupReducer
    }});
export default Store;